import { persistentReducedStream, reducer } from '@ardoq/rxbeach';
import { traversalConstructed } from './actions';
import type { PseudoTraversal } from './types';

const replaceConstructedTraversal = (
  _: PseudoTraversal | null,
  constructed: PseudoTraversal
): PseudoTraversal | null => constructed;

/** The pseudo-traversal last matched to metamodel traversals. */
export const constructedTraversal$ =
  persistentReducedStream<PseudoTraversal | null>(
    'traversalBuildingConstructedTraversal$',
    null,
    [reducer(traversalConstructed, replaceConstructedTraversal)]
  );
